import {
    Ri24HoursFill,
    Ri4kFill,
    RiAccountCircleFill,
    RiAccountCircleLine,
    RiAddFill,
    RiAddLine,
    RiAi,
    RiAlertFill,
    RiAlertLine,
    RiAlignJustify,
    RiApps2Fill,
    RiArchiveDrawerFill,
    RiArchiveDrawerLine,
    RiArrowDownCircleFill,
    RiArrowDownLine,
    RiArrowDownSLine,
    RiArrowDropDownLine,
    RiArrowDropLeftLine,
    RiArrowDropUpLine,
    RiArrowGoBackLine,
    RiArrowLeftLine,
    RiArrowLeftSLine,
    RiArrowRightCircleFill,
    RiArrowRightLine,
    RiArrowRightSLine,
    RiArrowRightUpLine,
    RiArrowUpCircleFill,
    RiArrowUpCircleLine,
    RiArrowUpDoubleLine,
    RiArrowUpDownLine,
    RiArrowUpLine,
    RiArrowUpSLine,
    RiArticleFill,
    RiArticleLine,
    RiAttachment2,
    RiBankCard2Line,
    RiBankFill,
    RiBarChartLine,
    RiBearSmileLine,
    RiBilibiliLine,
    RiBillFill,
    RiBillLine,
    RiBold,
    RiBookmark3Fill,
    RiBookOpenFill,
    RiBox3Fill,
    RiBugLine,
    RiBuilding2Fill,
    RiBuilding2Line,
    RiBuilding4Line,
    RiCalculatorFill,
    RiCalendar2Fill,
    RiCalendarCheckFill,
    RiCalendarEventFill,
    RiCalendarEventLine,
    RiCalendarFill,
    RiCalendarLine,
    RiCameraLine,
    RiChat1Line,
    RiChat3Fill,
    RiChat3Line,
    RiChatCheckFill,
    RiChatCheckLine,
    RiChatSmile2Fill,
    RiCheckboxBlankCircleFill,
    RiCheckboxBlankCircleLine,
    RiCheckboxCircleFill,
    RiCheckboxCircleLine,
    RiCheckboxFill,
    RiCheckDoubleLine,
    RiCheckFill,
    RiCheckLine,
    RiCircleFill,
    RiCircleLine,
    RiCloseCircleFill,
    RiCloseCircleLine,
    RiCloseFill,
    RiCloseLargeLine,
    RiCloseLine,
    RiCodeBoxFill,
    RiCodeBoxLine,
    RiCodeLine,
    RiCodeSSlashFill,
    RiCodeSSlashLine,
    RiCodeView,
    RiComputerFill,
    RiContactsBook2Line,
    RiCornerDownRightLine,
    RiCurrencyLine,
    RiCustomerServiceFill,
    RiCustomerServiceLine,
    RiDeleteBin2Line,
    RiDeleteBin6Line,
    RiDeleteBin7Line,
    RiDeleteBinLine,
    RiDonutChartLine,
    RiDoorClosedLine,
    RiDoorOpenFill,
    RiDossierFill,
    RiDossierLine,
    RiDoubleQuotesL,
    RiDownloadCloud2Line,
    RiDownloadLine,
    RiDraftFill,
    RiDraftLine,
    RiDraggable,
    RiEarthFill,
    RiEarthLine,
    RiEdit2Fill,
    RiEdit2Line,
    RiEmotionHappyLine,
    RiErrorWarningFill,
    RiErrorWarningLine,
    RiExchangeBoxLine,
    RiExternalLinkLine,
    RiEyeFill,
    RiEyeLine,
    RiEyeOffFill,
    RiEyeOffLine,
    RiFile2Fill,
    RiFile2Line,
    RiFile3Fill,
    RiFileChartFill,
    RiFileChartLine,
    RiFileCodeFill,
    RiFileCopy2Line,
    RiFileCopyLine,
    RiFileEditLine,
    RiFileFill,
    RiFileLine,
    RiFileList2Fill,
    RiFileList2Line,
    RiFileListFill,
    RiFileListLine,
    RiFilePdfFill,
    RiFileShredFill,
    RiFileTransferLine,
    RiFileUserFill,
    RiFileUserLine,
    RiFilter3Line,
    RiFilterLine,
    RiFlagFill,
    RiFlashlightLine,
    RiFocus2Line,
    RiFolder2Fill,
    RiFolderFill,
    RiForbid2Fill,
    RiForbid2Line,
    RiForbidFill,
    RiFundsBoxLine,
    RiFundsLine,
    RiGiftLine,
    RiGitBranchFill,
    RiGithubFill,
    RiGithubLine,
    RiGlobalFill,
    RiGlobalLine,
    RiGroupLine,
    RiHandCoinFill,
    RiHandCoinLine,
    RiHardDrive2Fill,
    RiHeadphoneFill,
    RiHealthBookFill,
    RiHealthBookLine,
    RiHeartPulseFill,
    RiHeartPulseLine,
    RiHomeFill,
    RiHomeLine,
    RiHotelBedFill,
    RiImageFill,
    RiInboxArchiveLine,
    RiIndeterminateCircleLine,
    RiInformation2Line,
    RiInformationFill,
    RiInformationLine,
    RiItalic,
    RiKanbanView,
    RiKanbanView2,
    RiKeyboardBoxFill,
    RiLayout5Fill,
    RiLayout5Line,
    RiLayoutBottom2Fill,
    RiLayoutMasonryLine,
    RiLayoutRowFill,
    RiLinkedinBoxFill,
    RiLinkedinFill,
    RiLinkedinLine,
    RiLinkM,
    RiLinksLine,
    RiListCheck,
    RiListOrdered2,
    RiListSettingsLine,
    RiListUnordered,
    RiLiveFill,
    RiLock2Fill,
    RiLock2Line,
    RiLockFill,
    RiLockLine,
    RiLockUnlockFill,
    RiLockUnlockLine,
    RiLogoutBoxRFill,
    RiLogoutBoxRLine,
    RiLoopRightLine,
    RiMacbookFill,
    RiMacbookLine,
    RiMacLine,
    RiMailFill,
    RiMailLine,
    RiMailSendFill,
    RiMailSendLine,
    RiMapPin2Line,
    RiMapPinFill,
    RiMapPinLine,
    RiMapPinTimeLine,
    RiMegaphoneFill,
    RiMegaphoneLine,
    RiMenuLine,
    RiMicFill,
    RiMicLine,
    RiMicOffFill,
    RiMoneyDollarBoxFill,
    RiMoneyDollarBoxLine,
    RiMoneyDollarCircleFill,
    RiMoneyDollarCircleLine,
    RiMoreFill,
    RiMouseFill,
    RiMovieLine,
    RiNodeTree,
    RiNotification3Line,
    RiNotificationLine,
    RiPassExpiredLine,
    RiPauseCircleFill,
    RiPauseCircleLine,
    RiPencilFill,
    RiPencilLine,
    RiPencilRuler2Fill,
    RiPencilRuler2Line,
    RiPhoneFill,
    RiPhoneLine,
    RiPieChart2Line,
    RiPieChartFill,
    RiPieChartLine,
    RiPlayCircleFill,
    RiPlayFill,
    RiPlayLargeFill,
    RiPlayLine,
    RiPriceTag3Fill,
    RiPriceTag3Line,
    RiPulseLine,
    RiPuzzleFill,
    RiQuestionAnswerFill,
    RiQuestionAnswerLine,
    RiQuestionFill,
    RiQuestionLine,
    RiRadioButtonFill,
    RiReceiptLine,
    RiRecordCircleFill,
    RiRecordCircleLine,
    RiRefreshLine,
    RiRefund2Line,
    RiRefundLine,
    RiReplyLine,
    RiRestartFill,
    RiRestaurantFill,
    RiRoadMapFill,
    RiRoadsterFill,
    RiRotateLockLine,
    RiSafeFill,
    RiScalesFill,
    RiSearch2Line,
    RiSearchEyeFill,
    RiSearchEyeLine,
    RiSearchLine,
    RiSeedlingLine,
    RiSendPlaneFill,
    RiSendPlaneLine,
    RiSettings2Line,
    RiSettingsFill,
    RiSettingsLine,
    RiShare2Line,
    RiShieldCheckFill,
    RiShieldCheckLine,
    RiShieldCrossFill,
    RiShieldCrossLine,
    RiShieldUserFill,
    RiShipFill,
    RiShipLine,
    RiShoppingBag3Line,
    RiSignalTowerFill,
    RiSignalTowerLine,
    RiSignpostFill,
    RiSkullLine,
    RiSlackFill,
    RiSpam3Fill,
    RiSparkling2Line,
    RiSparklingFill,
    RiSpyFill,
    RiSquareFill,
    RiSquareLine,
    RiStackFill,
    RiStarFill,
    RiStarLine,
    RiStarSLine,
    RiStarSmileFill,
    RiStickyNoteLine,
    RiStore2Line,
    RiSubtractLine,
    RiSuitcaseFill,
    RiSuitcaseLine,
    RiSyringeLine,
    RiTable2,
    RiTaskFill,
    RiTaskLine,
    RiTBoxFill,
    RiTeamFill,
    RiTeamLine,
    RiTestTubeFill,
    RiThumbDownLine,
    RiThumbUpFill,
    RiTimeFill,
    RiTimeLine,
    RiTimerFill,
    RiToggleFill,
    RiToggleLine,
    RiToothLine,
    RiTrophyLine,
    RiUploadCloud2Fill,
    RiUploadCloud2Line,
    RiUser2Fill,
    RiUser2Line,
    RiUser3Fill,
    RiUser3Line,
    RiUserAddFill,
    RiUserAddLine,
    RiUserFill,
    RiUserFollowFill,
    RiUserFollowLine,
    RiUserLine,
    RiUserSearchFill,
    RiUserSearchLine,
    RiUserShared2Fill,
    RiUserShared2Line,
    RiUserSharedFill,
    RiUserSharedLine,
    RiUserStarLine,
    RiVerifiedBadgeFill,
    RiVideoFill,
    RiVideoLine,
    RiVideoOnLine,
    RiVipCrown2Fill,
    RiVipCrownLine,
    RiWhatsappFill,
    RiWhatsappLine,
    RiWindowFill,
} from '@remixicon/react';
import type { Ref } from 'react';

import { classNames, iconColorVar, type IconColor } from '~/utils/styles';

type IconType = (typeof PLATFORM_ICONS)[number];

export type IconVariants = (typeof VARIANTS)[number];

export const RemixIconsInUse = {
    Ri24HoursFill,
    Ri4kFill,
    RiAccountCircleFill,
    RiAccountCircleLine,
    RiAddFill,
    RiAddLine,
    RiAi,
    RiAlertFill,
    RiAlertLine,
    RiAlignJustify,
    RiArchiveDrawerFill,
    RiArchiveDrawerLine,
    RiArrowDownCircleFill,
    RiArrowDownLine,
    RiArrowDownSLine,
    RiArrowDropDownLine,
    RiArrowDropLeftLine,
    RiArrowDropUpLine,
    RiArrowGoBackLine,
    RiArrowLeftLine,
    RiArrowLeftSLine,
    RiArrowRightCircleFill,
    RiArrowRightLine,
    RiArrowRightSLine,
    RiArrowRightUpLine,
    RiArrowUpCircleFill,
    RiArrowUpCircleLine,
    RiArrowUpDoubleLine,
    RiArrowUpDownLine,
    RiArrowUpLine,
    RiArrowUpSLine,
    RiArticleFill,
    RiArticleLine,
    RiApps2Fill,
    RiAttachment2,
    RiBankFill,
    RiBankCard2Line,
    RiBarChartLine,
    RiBearSmileLine,
    RiBilibiliLine,
    RiBillFill,
    RiBillLine,
    RiBold,
    RiBookmark3Fill,
    RiBookOpenFill,
    RiBox3Fill,
    RiBugLine,
    RiBuilding2Fill,
    RiBuilding2Line,
    RiBuilding4Line,
    RiCalculatorFill,
    RiCalendar2Fill,
    RiCalendarCheckFill,
    RiCalendarEventFill,
    RiCalendarEventLine,
    RiCalendarFill,
    RiCalendarLine,
    RiCameraLine,
    RiChat1Line,
    RiChat3Fill,
    RiChat3Line,
    RiChatCheckFill,
    RiChatCheckLine,
    RiChatSmile2Fill,
    RiCheckboxBlankCircleFill,
    RiCheckboxBlankCircleLine,
    RiCheckboxCircleFill,
    RiCheckboxCircleLine,
    RiCheckboxFill,
    RiCheckDoubleLine,
    RiCheckFill,
    RiCheckLine,
    RiCircleFill,
    RiCircleLine,
    RiCloseCircleFill,
    RiCloseCircleLine,
    RiCloseFill,
    RiCloseLargeLine,
    RiCloseLine,
    RiCodeBoxFill,
    RiCodeBoxLine,
    RiCodeLine,
    RiCodeSSlashFill,
    RiCodeSSlashLine,
    RiCodeView,
    RiComputerFill,
    RiContactsBook2Line,
    RiCornerDownRightLine,
    RiCurrencyLine,
    RiCustomerServiceFill,
    RiCustomerServiceLine,
    RiDeleteBin2Line,
    RiDeleteBin6Line,
    RiDeleteBin7Line,
    RiDeleteBinLine,
    RiDonutChartLine,
    RiDoorClosedLine,
    RiDoorOpenFill,
    RiDossierFill,
    RiDossierLine,
    RiDoubleQuotesL,
    RiDownloadCloud2Line,
    RiDownloadLine,
    RiDraftFill,
    RiDraftLine,
    RiDraggable,
    RiEarthFill,
    RiEarthLine,
    RiEdit2Fill,
    RiEdit2Line,
    RiEmotionHappyLine,
    RiErrorWarningFill,
    RiErrorWarningLine,
    RiExchangeBoxLine,
    RiExternalLinkLine,
    RiEyeFill,
    RiEyeLine,
    RiEyeOffFill,
    RiEyeOffLine,
    RiFile2Fill,
    RiFile2Line,
    RiFile3Fill,
    RiFileChartFill,
    RiFileChartLine,
    RiFileCodeFill,
    RiFileCopy2Line,
    RiFileCopyLine,
    RiFileEditLine,
    RiFileFill,
    RiFileLine,
    RiFileList2Fill,
    RiFileList2Line,
    RiFileListFill,
    RiFileListLine,
    RiFilePdfFill,
    RiFileShredFill,
    RiFileTransferLine,
    RiFileUserFill,
    RiFileUserLine,
    RiFilter3Line,
    RiFilterLine,
    RiFlagFill,
    RiFlashlightLine,
    RiFocus2Line,
    RiFolder2Fill,
    RiFolderFill,
    RiForbid2Fill,
    RiForbid2Line,
    RiForbidFill,
    RiFundsBoxLine,
    RiFundsLine,
    RiGiftLine,
    RiGitBranchFill,
    RiGithubFill,
    RiGithubLine,
    RiGlobalFill,
    RiGlobalLine,
    RiGroupLine,
    RiHandCoinFill,
    RiHandCoinLine,
    RiHardDrive2Fill,
    RiHeadphoneFill,
    RiHealthBookFill,
    RiHealthBookLine,
    RiHeartPulseFill,
    RiHeartPulseLine,
    RiHomeFill,
    RiHomeLine,
    RiHotelBedFill,
    RiImageFill,
    RiInboxArchiveLine,
    RiIndeterminateCircleLine,
    RiInformation2Line,
    RiInformationFill,
    RiInformationLine,
    RiItalic,
    RiKanbanView,
    RiKanbanView2,
    RiKeyboardBoxFill,
    RiLayout5Fill,
    RiLayout5Line,
    RiLayoutBottom2Fill,
    RiLayoutMasonryLine,
    RiLayoutRowFill,
    RiLinkedinBoxFill,
    RiLinkedinFill,
    RiLinkedinLine,
    RiLinkM,
    RiLinksLine,
    RiListCheck,
    RiListOrdered2,
    RiListSettingsLine,
    RiListUnordered,
    RiLiveFill,
    RiLock2Fill,
    RiLock2Line,
    RiLockFill,
    RiLockLine,
    RiLockUnlockFill,
    RiLockUnlockLine,
    RiLogoutBoxRFill,
    RiLogoutBoxRLine,
    RiLoopRightLine,
    RiMacbookFill,
    RiMacbookLine,
    RiMacLine,
    RiMailFill,
    RiMailLine,
    RiMailSendFill,
    RiMailSendLine,
    RiMapPin2Line,
    RiMapPinFill,
    RiMapPinLine,
    RiMapPinTimeLine,
    RiVideoLine,
    RiVideoOnLine,
    RiMegaphoneFill,
    RiMegaphoneLine,
    RiMenuLine,
    RiMicFill,
    RiMicLine,
    RiMicOffFill,
    RiMoneyDollarBoxFill,
    RiMoneyDollarBoxLine,
    RiMoneyDollarCircleFill,
    RiMoneyDollarCircleLine,
    RiMoreFill,
    RiMouseFill,
    RiMovieLine,
    RiNodeTree,
    RiNotification3Line,
    RiNotificationLine,
    RiPassExpiredLine,
    RiPauseCircleFill,
    RiPauseCircleLine,
    RiPencilFill,
    RiPencilLine,
    RiPencilRuler2Fill,
    RiPencilRuler2Line,
    RiPhoneFill,
    RiPhoneLine,
    RiPieChart2Line,
    RiPieChartFill,
    RiPieChartLine,
    RiPlayCircleFill,
    RiPlayFill,
    RiPlayLargeFill,
    RiPlayLine,
    RiPriceTag3Fill,
    RiPriceTag3Line,
    RiPulseLine,
    RiPuzzleFill,
    RiQuestionAnswerFill,
    RiQuestionAnswerLine,
    RiQuestionFill,
    RiQuestionLine,
    RiRadioButtonFill,
    RiReceiptLine,
    RiRecordCircleFill,
    RiRecordCircleLine,
    RiRefreshLine,
    RiRefund2Line,
    RiRefundLine,
    RiReplyLine,
    RiRestartFill,
    RiRestaurantFill,
    RiRoadMapFill,
    RiRoadsterFill,
    RiRotateLockLine,
    RiSafeFill,
    RiScalesFill,
    RiSearch2Line,
    RiSearchEyeFill,
    RiSearchEyeLine,
    RiSearchLine,
    RiSeedlingLine,
    RiSendPlaneFill,
    RiSendPlaneLine,
    RiSettings2Line,
    RiSettingsFill,
    RiSettingsLine,
    RiShare2Line,
    RiShieldCheckFill,
    RiShieldCheckLine,
    RiShieldCrossFill,
    RiShieldCrossLine,
    RiShieldUserFill,
    RiShipFill,
    RiShipLine,
    RiShoppingBag3Line,
    RiSignalTowerFill,
    RiSignalTowerLine,
    RiSignpostFill,
    RiSkullLine,
    RiSlackFill,
    RiSpam3Fill,
    RiSparkling2Line,
    RiSparklingFill,
    RiSpyFill,
    RiSquareFill,
    RiSquareLine,
    RiStackFill,
    RiStarFill,
    RiStarLine,
    RiStarSLine,
    RiStarSmileFill,
    RiStickyNoteLine,
    RiStore2Line,
    RiSubtractLine,
    RiSuitcaseFill,
    RiSuitcaseLine,
    RiSyringeLine,
    RiTable2,
    RiTaskFill,
    RiTaskLine,
    RiTBoxFill,
    RiTeamFill,
    RiTeamLine,
    RiTestTubeFill,
    RiThumbDownLine,
    RiThumbUpFill,
    RiTimeFill,
    RiTimeLine,
    RiTimerFill,
    RiToggleFill,
    RiToggleLine,
    RiToothLine,
    RiTrophyLine,
    RiUploadCloud2Fill,
    RiUploadCloud2Line,
    RiUser2Fill,
    RiUser2Line,
    RiUser3Fill,
    RiUser3Line,
    RiUserAddFill,
    RiUserAddLine,
    RiUserFill,
    RiUserFollowFill,
    RiUserFollowLine,
    RiUserLine,
    RiUserSearchFill,
    RiUserSearchLine,
    RiUserShared2Fill,
    RiUserShared2Line,
    RiUserSharedFill,
    RiUserSharedLine,
    RiUserStarLine,
    RiVerifiedBadgeFill,
    RiVideoFill,
    RiVipCrown2Fill,
    RiVipCrownLine,
    RiWhatsappFill,
    RiWhatsappLine,
    RiWindowFill,
};

type RemixIconName = keyof typeof RemixIconsInUse;
export const RemixIconNames = Object.fromEntries(
    Object.keys(RemixIconsInUse).map((k) => [k, k]),
) as {
    [K in keyof typeof RemixIconsInUse]: K;
};

export type IconNames = RemixIconName | IconType;

export type IconProps = {
    icon: IconNames;
    className?: string;
    colorVar?: IconColor;
    size?: number;
    variant?: IconVariants;
    ref?: Ref<SVGElement | HTMLSpanElement>;
};

export default function Icon({
    icon,
    className = '',
    colorVar,
    size = 16,
    variant = 'inherit',
    ref,
}: IconProps) {
    const isRemixIcon = Object.keys(RemixIconsInUse).includes(icon);

    const ReIcon = RemixIconsInUse[icon as RemixIconName];

    // sets the color through the css variable --icon-color
    const colorVarStyle = colorVar
        ? { '--icon-color': `var(--color, var(${iconColorVar(colorVar)}))` }
        : {};

    return isRemixIcon ? (
        <ReIcon
            data-icon-name={icon}
            size={size}
            className={classNames({
                [`rt-icon icon-remix-${variant}`]: true,
                [className]: Boolean(className),
                'icon-color': Boolean(colorVar),
            })}
            style={colorVarStyle}
            ref={ref as Ref<SVGSVGElement>}
        />
    ) : (
        <span
            ref={ref as Ref<HTMLSpanElement>}
            data-icon-name={icon}
            className={classNames({
                [`rt-icon icon icon-${icon} icon-${variant}`]: true,
                [className]: Boolean(className),
                'icon-bg-color': Boolean(colorVar),
            })}
            style={{ width: `${size}px`, height: `${size}px`, ...colorVarStyle }}
        />
    );
}

export const VARIANTS = [
    'inherit',
    'primary',
    'secondary',
    'white',
    'success',
    'light',
    'danger',
    'warn',
    'gradient',
    'cranberry',
] as const;

export const PLATFORM_ICONS = [
    // add here custom icons not available in remixicon
    'crunchbase',
    'empty-generic',
    'info-big',
    'loading',
    'mercury',
    'phone',
    'phone-slash',
    'referral',
    'schedule-stage',
    'success-thin',
    'warn-big',
    'sso-google',
    'remotely',
] as const;
